import { GetCustomReportSchemaContract } from '../../schemas/GetCustomReportSchema';

/**
 * Filters out hidden columns and returns an array of their keys
 */
export const filterHiddenColumns = (
  columns?: GetCustomReportSchemaContract['response']['columns']
): string[] => {
  if (!columns) {
    return [];
  }
  
  return columns
    .filter((column) => column.config?.isHidden)
    .map((column) => column.key) || [];
}; 